<template>
    <MasterTemplate 
        title="ข้อมูลรถ" 
        :headers="headers" 
        :setData="setData"
        itemKey="carId"
        :getItemName="getItemName"
        :deleteData="deleteData"
        :insertData="insertData"
        :updateData="updateData"
        :listData="listData"
        >
        <template v-slot:formInput="{rules}">
            <v-row>
                <v-col cols="" >
                    <v-autocomplete
                        v-model="editedItem.branchCode"
                        label="สาขา"
                        :items="branchs"
                        item-text="branchName"
                        item-value="branchCode"
                        :rules="[rules.required]"
                        outlined
                    >
                    </v-autocomplete>
                </v-col>
                <v-col cols="4" >
                    <v-text-field label="เลขทะเบียน" autofocus maxlength="20" v-model="editedItem.licenseNo" :rules="[rules.required]"></v-text-field>
                </v-col>
                <v-col cols="4" >
                    <v-text-field  label="จังหวัด" maxlength="50" v-model="editedItem.licenseNoProvince" :rules="[rules.required]"></v-text-field>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="4" >
                    <v-text-field label="เลขตัวถัง"  maxlength="20" v-model="editedItem.bodyNumber" :rules="[rules.required]"></v-text-field>
                </v-col>
                <v-col cols="4" >
                    <v-text-field  label="เลขเครื่อง" maxlength="20" v-model="editedItem.engineNumber" :rules="[rules.required]"></v-text-field>
                </v-col>
                 <v-col cols="4" >
                    <v-text-field  label="แบบรถ" maxlength="50" v-model="editedItem.bodyType" :rules="[rules.required]"></v-text-field>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="4" >
                    <v-select
                        v-model="editedItem.brandCode"
                        :items="brands"
                        label="ยี่ห้อ"
                        item-text="name"
                        item-value="value"
                    ></v-select>
                </v-col>
                <v-col cols="4" >
                    <v-select
                        v-model="editedItem.modelCode"
                        :items="models"
                        label="รุ่น"
                        item-text="name"
                        item-value="value"
                    ></v-select>
                </v-col>

                <v-col cols="4" >
                    <v-select
                        v-model="editedItem.colorCode"
                        :items="colors"
                        label="สี"
                        item-text="name"
                        item-value="value"
                    ></v-select>
                </v-col>
            </v-row>

        </template>
    </MasterTemplate>
</template>

<script>

    import MasterTemplate from '@/components/MasterTemplate'
    import {listCar, insertCar, updateCar, deleteCar, existCar} from '@/api/master/car-api.js'
    import {listDropdownBrand, listDropdownModel, listDropdownColor} from '@/api/common/dropdown-api.js'
    import {listBranch} from '@/api/master/branch-api.js'

export default {
    name: 'Car',
    components: {
        MasterTemplate
    },
    watch: {
        'editedItem.brandCode': function(newVal) {
            listDropdownModel(newVal).then(rs => {
                this.models = rs.data
            });
            listDropdownColor(newVal).then(rs => {
                this.colors = rs.data
            });
        }
    },
    data: () => ({
        isDup: false,
        branchs: [],
        headers: [
            {text: 'เลขทะเบียน', value: 'licenseNo'},
            {text: 'จังหวัด', value: 'licenseNoProvince'},
            {text: 'ยี่ห้อ', value: 'brandName'},
            {text: 'รุ่น', value: 'modelName'},
            {text: 'Actions', value: 'action', sortable: false}
        ],
        editedItem: {
            carId: '-1',
            licenseNo: '',
            licenseNoProvince: '',
            bodyNumber: '',
            engineNumber: '',
            modelCode: '',
            brandCode: '',
            bodyType: '',
            colorCode: '',
            branchCode: ''
        },
        brands: [],
        models: [],
        colors: []
    }),
    methods: {
        listData() {
            return listCar();
        },
        deleteData(item) {
            return deleteCar(item.carId);
        },
        insertData() {

            return new Promise((resolve, reject) => {
                existCar(this.editedItem.licenseNo, this.editedItem.modelCode, this.editedItem.branchCode).then((rs) => {
                    if (rs) {
                        alert("ข้อมูลรถซ้ำ");
                        reject(true);
                    }
                    resolve(insertCar(this.editedItem));
                });
                
            });
        },
        updateData() {
            return updateCar(this.editedItem);
        },
        getItemName(item) {
            return item.licenseNo;
        },
        setData(item) {
            this.editedItem = item;
        },
    },
    mounted() {
        listBranch().then(rs => {
            this.branchs = rs;
        });
        listDropdownBrand().then(rs => {
            listBranch().then(rs => {
                this.branchs = rs;
            });
            this.brands = rs.data
        });
    }
}
</script>